// Dev-only MOCK leak data, so the Home "Leak detected" badge, its detail
// modal, and the Trends overlay can be previewed on localhost before the real
// leak scan writes any leakStats. Enable with ?leakdemo=1 (sticky per
// browser); ?leakdemo=0 clears it. ?leakdemo=rapid / ?leakdemo=away preview
// those variants of the badge modal. In production the badge lights for slow,
// away (48h window) and rapid (24h) alike. Disabled → returns nothing, so
// normal localhost and production show no leak UI.
//
// When the backend goes live, getLeakStatus / getLeakRegions get swapped for
// reads of devices/{id}/leakStats; the component contracts stay the same.

const H = 3600000;

// Raw ?leakdemo value ('1' | 'rapid' | 'away' | '0' | null), sticky per browser.
function demoValue() {
  try {
    const p = new URLSearchParams(window.location.search);
    const q = p.get('leakdemo');
    if (q != null) {
      if (q === '0') { window.localStorage.removeItem('soko.leakDemo'); return null; }
      window.localStorage.setItem('soko.leakDemo', q);
      return q;
    }
    return window.localStorage.getItem('soko.leakDemo');
  } catch { return null; }
}

export function leakDemoEnabled() {
  const v = demoValue();
  return !!v && v !== '0';
}

function demoKind() {
  const v = demoValue();
  return v === 'rapid' ? 'rapid' : v === 'away' ? 'away' : 'slow';
}

// Badge windows: slow/away leaks show for 48h, rapid/heavy-usage for 24h.
export const LEAK_BADGE_WINDOW_MS = 48 * H;
export const RAPID_BADGE_WINDOW_MS = 24 * H;

// Per-tank leak status for the Home badge + its modal. In production only
// slow-leak / away-mode leaks reach the badge (rapid/heavy-use is excluded);
// the rapid case here is a preview knob. Keyed by tank number. {} when off.
export function getLeakStatus(deviceId) {
  if (!leakDemoEnabled() || !deviceId) return {};
  const now = Date.now();
  const kind = demoKind();
  if (kind === 'rapid') {
    // Heavy-use / rapid drop: a finished event, with the observed drop and the
    // rule threshold that tripped it.
    return {
      1: {
        active: true, kind: 'rapid',
        startTs: now - 20 * H, endTs: now - 19 * H,
        gallons: 200, windowMinutes: 30, observedGal: 240,
      },
    };
  }
  // Slow leak / away: ongoing (no end yet).
  return { 1: { active: true, kind, startTs: now - 9 * H, endTs: null } };
}

// Leak regions for the Trends overlay. endTs === null means ongoing (band runs
// to now). kind 'slow' = lighter orange, 'rapid' = darker orange. [] when off.
export function getLeakRegions(deviceId) {
  if (!leakDemoEnabled() || !deviceId) return [];
  const now = Date.now();
  return [
    { tankNum: 1, kind: 'slow',  startTs: now - 40 * H, endTs: now - 33 * H },
    { tankNum: 1, kind: 'rapid', startTs: now - 20 * H, endTs: now - 19 * H, observedGal: 240 },
    { tankNum: 1, kind: 'away',  startTs: now - 14 * H, endTs: now - 12 * H },
    { tankNum: 1, kind: 'slow',  startTs: now - 9 * H,  endTs: null },
  ];
}
